module.exports = __webpack_public_path__ + "media/site/images/products/actionplan-flat-screen@2x-73537959cf7e50b5fa383f7fce65eb4e.png";